module.exports = __webpack_public_path__ + "img/alp_logo.ba9b3e42.jpg";